module.exports = __webpack_public_path__ + "img/01efaef.jpg";